<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>
<script>
import { DynamicRoutes } from "@/router/permission.js";

export default {
  mounted() {
    this.$refs.app.style.height = document.documentElement.clientHeight + "px";

    // 保证刷新后，重新获取权限数据
    DynamicRoutes();
  },
};
</script>
<style lang="less" scoped>
#app {
  overflow: hidden;
  background: #f7f8fa;
}
</style>

